import{isServer as n}from"lit";var o=(r,s)=>!r||n?"":s.reduce((t,e)=>`${t} ${r.contains(e)?e:""}`,"");export{o as a};
//# sourceMappingURL=chunk.D5JL2GYW.js.map
